<template>
  <section class="sac-steps">
    <div class="wrapper">
      <ul class="steps-nav" :class="'steps-nav--' + model.etapaAtiva">
        <li>
          <span class="step">1</span>
          <span class="title">{{ _e('sac_step1_label') }}</span>
        </li>
        <li>
          <span class="step">2</span>
          <span class="title">{{ _e('sac_step2_label') }}</span>
        </li>
        <li>
          <span class="step">3</span>
          <span class="title">{{ _e('sac_step3_label') }}</span>
        </li>
      </ul>
      <h3 class="steps-title-mob title"> {{ activeTitle }}</h3>
    </div>
  </section>
</template>
<script setup>
import { computed } from 'vue';
import { _e } from '../../../helpers/l10n';
import { useSacStore } from '../../../store/SacStore';

const model = useSacStore();

const activeTitle = computed(() => {
  switch(model.etapaAtiva) {
    case 1:
      return _e('sac_step1_label');
    case 2:
      return _e('sac_step2_label');
    case 3:
      return _e('sac_step3_label');
  }
});
</script>
